import { render, staticRenderFns } from "./SectionsEdit.vue?vue&type=template&id=af609184"
import script from "./SectionsEdit.vue?vue&type=script&lang=js"
export * from "./SectionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports